__turbopack_context__.v({
  "h1": "PlasmicAccount-module__dBjwlW__h1",
  "layout2": "PlasmicAccount-module__dBjwlW__layout2",
  "root": "PlasmicAccount-module__dBjwlW__root",
  "section": "PlasmicAccount-module__dBjwlW__section",
  "sideEffect": "PlasmicAccount-module__dBjwlW__sideEffect",
  "supabaseLoginLogoutForm": "PlasmicAccount-module__dBjwlW__supabaseLoginLogoutForm",
});
